import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconOpenInNewOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M22.5 12H24v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10v1.5H2a.5.5 0 0 0-.5.5v20a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5zm-12.451 2.959L9 13.923 21.447 1.48h-5.47a.74.74 0 0 1 0-1.479h7.995v7.996a.74.74 0 1 1-1.48 0V2.525z" /></svg>
);
